<template>
  <v-tooltip :disabled="canPerformAction" open-delay="500" location="start">
    <template #activator="{ props }">
      <v-list-item
        @click="canPerformAction ? $emit('set-action', action) : undefined"
        :link="canPerformAction"
        :class="`test-${action}`"
        :ripple="canPerformAction"
        v-bind="props"
      >
        <v-list-item-title
          :class="{
            'text-grey': !canPerformAction,
          }"
        >
          <v-icon class="mr-1" size="small">{{ icon }}</v-icon>
          {{ label }}
        </v-list-item-title>
      </v-list-item>
    </template>
    <span v-if="disabledMessage"> {{ disabledMessage }} </span>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { EditTextAction } from '@oare/types';

export default defineComponent({
  props: {
    canPerformAction: {
      type: Boolean,
      required: true,
    },
    action: {
      type: String as PropType<EditTextAction>,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    disabledMessage: {
      type: String,
      required: false,
    },
  },
  emits: ['set-action'],
});
</script>
